export default __webpack_public_path__ + "static/media/use1.b323eabb.png";